import { render } from "./App.vue?vue&type=template&id=4bde15b6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4bde15b6&lang=scss"
script.render = render

export default script